import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

export default function InputMaskHeight(props) {
  const { inputRef, onChange, ...inputMaskProps } = props;
  const [isDefaultSet, setIsDefaultSet] = useState(false);

  const beforeMaskedValueChange = (newState, oldState, userInput) => {
    var { value } = newState;
    var selection = newState.selection;
    var cursorPosition = selection ? selection.start : null;

    function incrementCursorPosition() {
      cursorPosition++;
      selection = { start: cursorPosition, end: cursorPosition };
    }

    // if string doesn't end with inches value and not set default zero already
    if (value.charAt(5) === ' ' && value.charAt(6) === ' ' && value.charAt(0) !== ' ' && !isDefaultSet) {
      incrementCursorPosition();
      // add zero for inches
      value = value.slice(0, 5) + '0' + value.slice(5);

      setIsDefaultSet(true);
    }
    // if string end with inch value (Edit mode)
    else if (!(value.charAt(5) === ' ' && value.charAt(6) === ' ') && !isDefaultSet && value !== '') {
      setIsDefaultSet(true);
    }
    // Manage extra addition on first load in inches size
    else if ( cursorPosition === 7 && userInput) {
      value = value.slice(0, 6) + userInput + value.slice(7);
    }
    // Manage extra addition on first load in inches size
    else if ( cursorPosition === 10 && userInput) {
      value = value.replace(value.charAt(5), value.charAt(6));
      value = value.substring(0, 6) + value.substring(7, value.length);
      value = value.slice(0, 6) + userInput + value.slice(6);
  }
    return {
      value,
      selection
    };
  }

  return (
    <InputMask
      {...inputMaskProps}
      inputRef={inputRef}
      onChange={props.onChange}
      mask="9 ft 99 in"
      maskChar=" "
      beforeMaskedValueChange={beforeMaskedValueChange}
    />
  );
}

InputMaskHeight.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/InputMaskHeight.js